
var Model = require("../types/Model.js");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

/**
 * Handles the positioning of the local video stream
 * @type {Model}
 */
module.exports = Model({
	name: "videoposition",
	init: init
});

function init() {
	this.on("trigger:change", handle_trigger_change.bind(this));

	return AsyncStorage.getItem("videoposition").then(function(videoposition){
		var position = videoposition || "NE";
		return this.push(position);
	}.bind(this));
}

function handle_trigger_change(data) {
	var position = data.position;
	if (!position) return;
	AsyncStorage.setItem("videoposition", position);
	this.push(position);
}
